import Cookies from "js-cookie";

interface MatkontoTmpVerifyInfo {
    municipalityId: string;
    customerId: string;
    unitId: string;
}

const MATKONTO_COOKIE_KEY = "MatkontoVerifyInfo";

// This is temporary crap - when going back from Matkonto payex, we need to call "verify" endpoint with previously selected customer.
// We keep that in a cookie, so we must delete that cookie on every page that is not a matkonto callback page
// This needs to be fixed on Hybrs endpoint by giving us customerId and unitId i.e. as a query string parameters when calling our 'callback/matkonto' redirect.
export const MatkontoTmpInfoProvider = {
    get: (): MatkontoTmpVerifyInfo | null => {
        const matkontoCookie = Cookies.get(MATKONTO_COOKIE_KEY);
        if (!matkontoCookie) return null;

        const tmpCustomerInfo: MatkontoTmpVerifyInfo =
            JSON.parse(matkontoCookie);

        if (
            tmpCustomerInfo.customerId &&
            tmpCustomerInfo.unitId &&
            tmpCustomerInfo.municipalityId
        ) {
            return tmpCustomerInfo;
        } else return null;
    },

    set: (data: MatkontoTmpVerifyInfo) => {
        Cookies.set(MATKONTO_COOKIE_KEY, JSON.stringify(data));
    },

    remove: () => {
        Cookies.remove(MATKONTO_COOKIE_KEY);
    },

    exists: (): boolean => {
        const matkontoCookie = Cookies.get(MATKONTO_COOKIE_KEY);
        return !!matkontoCookie;
    },
};

const MATKONTO_VERIFIED_CODE_KEY = "MatkontoVerifiedCode";

/** Tracks the last verified transaction code so Back/re-entry does not re-call the provider. One at a time. */
export const MatkontoVerifiedCodes = {
    has: (code: string): boolean => {
        return sessionStorage.getItem(MATKONTO_VERIFIED_CODE_KEY) === code;
    },

    add: (code: string): void => {
        sessionStorage.setItem(MATKONTO_VERIFIED_CODE_KEY, code);
    },
};
